import React from "react";

import { Container, Row, Col, ListGroup, ListGroupItem } from "reactstrap";
import { Link } from "react-router-dom";
import "../../styles/footer.css";

const quickLinks = [
  {
    path: "/about",
    display: "About",
  },

  {
    path: "#",
    display: "Privacy Policy",
  },

  {
    path: "/cars",
    display: "Car Listing",
  },
  {
    path: "/blogs",
    display: "Blog",
  },

  {
    path: "/contact",
    display: "Contact",
  },
];

const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="justify-content-center">
          <Col lg="4" md="4" sm="12">
            <div className="logo footer__logo">
              <h1>
                <Link to="/home" className=" d-flex align-items-center gap-2">
                  <img
                    src="/img/logo2.png"
                    alt="logo"
                    style={{ maxWidth: "250px", maxHeight: "250px" }}
                  /> 
                  {/* <span>
                  Sankhu Car Rental <br /> and Tours
                  </span> */}
                </Link>
              </h1>
            </div>
            <p className="footer__logo-content">
              Your Gateway to Kenyan Adventure.
              Explore the beauty and culture of Kenya with our dependable car
              rental and tour services. Get in touch with us today and start
              your journey of a lifetime.
            </p>
          </Col>

          <Col lg="2" md="4" sm="6">
            <div className="mb-4">
              <h5 className="footer__link-title">Quick Links</h5>
              <ListGroup>
                {quickLinks.map((item, index) => (
                  <ListGroupItem key={index} className="p-0 mt-3 quick__link">
                    <Link to={item.path}>{item.display}</Link>
                  </ListGroupItem>
                ))}
              </ListGroup>
            </div>
          </Col>

          <Col lg="4" md="4" sm="6">
            <div className="mb-4">
              <h5 className="footer__link-title mb-4">Head Office</h5>
              <p className="office__info">
              Hurlingham Plaza, Argwings Kodhek. Nairobi, Kenya. <br />
              Nairobi, Kenya. (2nd Floor Rm C14)
              </p>
              <p className="office__info">Office Phone: +254113474733<br />
              Mobile Phone: +254115554156<br />
              Whatsapp: +254750542046</p>

              <p className="office__info">Email: info.sankhultd@gmail.com</p>

              <p className="office__info">Office Time: 8am - 6pm</p>
            </div>
          </Col>

          

          <Col lg="12">
            <div className="footer__bottom">
              <p className="section__description d-flex align-items-center justify-content-center gap-1 pt-4">
                <i class="ri-copyright-line"></i>
                Powered with ♥ by{" "}
                <a href="https://tratechsolutions.co.ke/">Tratech Solutions</a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
